import { atom } from 'jotai';

export const isCompanyEditModalOpenAtom = atom(false);
isCompanyEditModalOpenAtom.debugLabel = 'isCompanyEditModalOpenAtom';
